(function () {
  "use strict";

  var ENDPOINT = "/apps/kit-checkout";
  var loadingClass = "btn--loading";

  function hasKitItems(cart) {
    return cart.items.some(function (item) {
      return item.properties && item.properties._kit_group;
    });
  }

  function normalizeCart(cart) {
    return {
      token: cart.token,
      note: cart.note,
      attributes: cart.attributes || {},
      items: cart.items.map(function (item) {
        return {
          key: item.key,
          variant_id: item.variant_id,
          product_id: item.product_id,
          quantity: item.quantity,
          properties: item.properties || {},
          original_price: item.original_price,  // Shopify regular price (cents) — used for discount calc
        };
      }),
    };
  }

  function getCart() {
    return fetch("/cart.js", {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    }).then(function (response) {
      if (!response.ok) throw new Error("Nao foi possivel ler o carrinho.");
      return response.json();
    });
  }

  function createDraftCheckout(cart) {
    return fetch(ENDPOINT, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
        Accept: "application/json",
      },
      body: JSON.stringify({ cart: normalizeCart(cart) }),
    }).then(function (response) {
      return response.text().then(function (text) {
        var data;
        try { data = JSON.parse(text); } catch (e) {
          throw new Error("Erro ao processar o checkout. Por favor, tente novamente.");
        }
        if (!response.ok || !data.checkout_url) {
          throw new Error(data.error || data.message || "Não foi possível iniciar o checkout do kit.");
        }
        return data.checkout_url;
      });
    });
  }

  function termsAccepted(form) {
    var checkbox = form.querySelector(".cart__terms-checkbox");
    if (!checkbox || checkbox.checked) return true;

    alert(
      window.theme && theme.strings
        ? theme.strings.cartTermsConfirmation
        : "Aceite os termos para continuar.",
    );
    return false;
  }

  function setLoading(form, loading) {
    var button = form.querySelector('[name="checkout"], .cart__checkout');
    if (!button) return;

    button.classList.toggle(loadingClass, loading);
    button.disabled = loading;
  }

  function handleSubmit(event) {
    var form = event.target;
    if (!form || !form.matches('form[action*="/cart"], #CartDrawerForm'))
      return;
    if (!form.querySelector('[name="checkout"], .cart__checkout')) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (!termsAccepted(form)) return;

    setLoading(form, true);

    getCart()
      .then(function (cart) {
        if (!hasKitItems(cart)) {
          if (!form.querySelector('input[type="hidden"][name="checkout"]')) {
            var checkoutInput = document.createElement("input");
            checkoutInput.type = "hidden";
            checkoutInput.name = "checkout";
            checkoutInput.value = "checkout";
            form.appendChild(checkoutInput);
          }

          form.submit();
          return null;
        }

        return createDraftCheckout(cart).then(function (checkoutUrl) {
          window.location.href = checkoutUrl;
        });
      })
      .catch(function (error) {
        alert(error.message);
        setLoading(form, false);
      });
  }

  document.addEventListener("submit", handleSubmit, true);

  // AJAX remove handler for kit cart items — fires cart:updated so watchKitCart reacts
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-kit-remove]");
    if (!btn) return;
    e.preventDefault();
    var key = btn.dataset.kitRemove;
    btn.disabled = true;
    fetch("/cart/change.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
      body: JSON.stringify({ id: key, quantity: 0 }),
    }).then(function () {
      document.dispatchEvent(new CustomEvent("cart:updated"));
      document.dispatchEvent(new CustomEvent("cart:build"));
    }).catch(function () {
      btn.disabled = false;
    });
  });

  // Strip kit-only properties (leading "_kit_" + the display labels the kit
  // builder adds) so a leftover piece reverts to a normal standalone cart line.
  function stripKitProperties(props) {
    var out = {};
    Object.keys(props || {}).forEach(function (k) {
      if (k.indexOf("_kit_") === 0) return;
      var lower = k.toLowerCase();
      if (lower === "promoção" || lower === "promocao" || lower === "peça" || lower === "peca") return;
      out[k] = props[k];
    });
    return out;
  }

  // Shopify formats variant_title as "OptionA / OptionB"; this theme's kit
  // variants always put color first (see buildVariantsFromShopify in
  // kit-builder.js), so the first segment is a best-effort color guess used
  // to keep the same gift color across a tier swap when it's available.
  function guessColorFromVariantTitle(item) {
    if (!item || !item.variant_title) return null;
    var parts = String(item.variant_title).split(" / ");
    return parts[0] || null;
  }

  // Remove brinde + update prices/labels when kit tier drops (runs on all pages)
  function watchKitCart() {
    function checkCart() {
      fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var groups = {};
          (cart.items || []).forEach(function (item) {
            var props = item.properties || {};
            var groupId = props._kit_group;
            if (!groupId) return;
            if (!groups[groupId]) groups[groupId] = { tier: Number(props._kit_tier || 0), paid: [], gifts: [] };
            if (props._kit_gift === "true" || props._kit_slot === "gift") {
              groups[groupId].gifts.push(item);
            } else {
              groups[groupId].paid.push(item);
            }
          });

          var changes = [];
          var adds = [];

          Object.keys(groups).forEach(function (id) {
            var g = groups[id];
            var paidCount = g.paid.reduce(function (s, i) { return s + Number(i.quantity || 1); }, 0);

            // Whole kit was removed except a stray gift left behind — clean it up
            if (paidCount === 0) {
              g.gifts.forEach(function (item) { changes.push({ id: item.key, quantity: 0 }); });
              return;
            }

            if (!g.paid.length) return;

            var firstPaid = g.paid[0];
            var firstProps = firstPaid.properties || {};
            var pricesStr = firstProps._kit_tier_prices || "{}";
            var labelsStr = firstProps._kit_tier_labels || "{}";
            var giftsStr = firstProps._kit_tier_gifts || "{}";
            var kitId = firstProps._kit_id || "";
            var tierPrices, tierLabels, tierGifts;
            try { tierPrices = JSON.parse(pricesStr); } catch (e) { tierPrices = {}; }
            try { tierLabels = JSON.parse(labelsStr); } catch (e) { tierLabels = {}; }
            try { tierGifts = JSON.parse(giftsStr); } catch (e) { tierGifts = {}; }

            var newPrice = tierPrices[String(paidCount)];

            // Quantity doesn't match any configured kit tier (e.g. Kit 2 -> 1
            // peça leftover, Kit 6 -> 5/3 peças). That's not a broken bundle —
            // it's just no longer a kit, so convert the remaining piece(s) into
            // normal standalone lines (native price, no kit properties) instead
            // of wiping the whole cart. Any attached gift no longer applies.
            if (!newPrice) {
              g.paid.forEach(function (item) {
                changes.push({ id: item.key, quantity: item.quantity, properties: stripKitProperties(item.properties) });
              });
              g.gifts.forEach(function (item) { changes.push({ id: item.key, quantity: 0 }); });
              return;
            }

            // Does the gift currently in the cart still belong to the tier we
            // just landed on? (tierGifts[qty].variants lists that tier's valid
            // gift variant ids.) If not, drop it — and if the new tier is
            // itself entitled to a (possibly different) gift, add its default
            // variant instead of just leaving the customer without one.
            var newGiftEntry = tierGifts[String(paidCount)] || null;
            var currentGiftVariantIds = g.gifts.map(function (i) { return i.variant_id; });
            var giftMatchesNewTier = !!(newGiftEntry && newGiftEntry.variants.some(function (v) {
              return currentGiftVariantIds.indexOf(v.id) >= 0;
            }));

            if (!giftMatchesNewTier) {
              g.gifts.forEach(function (item) { changes.push({ id: item.key, quantity: 0 }); });

              if (newGiftEntry) {
                var allowed = Array.isArray(newGiftEntry.allowed_colors) ? newGiftEntry.allowed_colors : null;
                var candidates = newGiftEntry.variants.filter(function (v) {
                  return v.available !== false && (!allowed || !v.color || allowed.indexOf(v.color) >= 0);
                });
                var prevColor = g.gifts[0] ? guessColorFromVariantTitle(g.gifts[0]) : null;
                var chosen = (prevColor && candidates.filter(function (v) { return v.color === prevColor; })[0]) || candidates[0];

                if (chosen) {
                  adds.push({
                    id: chosen.id,
                    quantity: 1,
                    properties: {
                      "Promoção": tierLabels[String(paidCount)] || ("Kit " + paidCount),
                      "Peça": "Brinde",
                      _kit_group: id,
                      _kit_id: kitId,
                      _kit_tier: String(paidCount),
                      _kit_slot: "gift",
                      _kit_gift: "true",
                    },
                  });
                }
              }
            }

            // Update price, label and Peça numbering when tier changed
            if (paidCount !== g.tier) {
              var newLabel = tierLabels[String(paidCount)] || ("Kit " + paidCount);
              var sortedPaid = g.paid.slice().sort(function (a, b) {
                return Number((a.properties || {})._kit_slot || 0) - Number((b.properties || {})._kit_slot || 0);
              });
              sortedPaid.forEach(function (item, idx) {
                var newProps = Object.assign({}, item.properties || {});
                newProps._kit_unit_price = String(newPrice);
                newProps._kit_tier = String(paidCount);
                newProps["Promoção"] = newLabel;
                newProps["Peça"] = String(idx + 1) + "/" + paidCount;
                changes.push({ id: item.key, quantity: item.quantity, properties: newProps });
              });
            }
          });

          if (!changes.length && !adds.length) return;

          changes.reduce(function (p, change) {
            return p.then(function () {
              return fetch("/cart/change.js", {
                method: "POST",
                credentials: "same-origin",
                headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
                body: JSON.stringify(change),
              });
            });
          }, Promise.resolve()).then(function () {
            if (!adds.length) return null;
            return fetch("/cart/add.js", {
              method: "POST",
              credentials: "same-origin",
              headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
              body: JSON.stringify({ items: adds }),
            });
          }).then(function () {
            document.dispatchEvent(new CustomEvent("cart:build"));
          });
        })
        .catch(function () {});
    }

    document.addEventListener("cart:updated", checkCart);
    // Also run once on page load to clean up stale state
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", checkCart);
    } else {
      checkCart();
    }
  }

  watchKitCart();
})();
